export { default as MarketingCaseSlot } from './MarketingCaseSlot';
